import { useEffect, useState } from 'react';
import { useDebounceCallback } from '@react-hook/debounce';
import { getRequiredScopes } from 'common/services/general.service';

const useRequiredScopes = ({ provider, authorizationLevel, tokenType }) => {
  const [requiredScopes, setRequiredScopes] = useState([]);

  const fetchScopes = useDebounceCallback(async () => {
    try {
      const requiredScopes = await getRequiredScopes(
        provider,
        authorizationLevel,
        tokenType
      );
      setRequiredScopes(requiredScopes);
    } catch (e) {
      setRequiredScopes([]);
    }
  }, 10);

  useEffect(() => {
    fetchScopes();
  }, [provider, authorizationLevel, tokenType]);

  return requiredScopes;
};

export default useRequiredScopes;
